export default "/_next/static/videos/e1d92cd7a7b3ceb6ac67d5d48ce694c2.mp4";